var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('div',{staticClass:"main-content"},[_c('Header'),_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view',{key:_vm.viewKey}):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view',{key:_vm.viewKey}):_vm._e()],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }